export default [
	// {
	// 	path: "/booking-old",
	// 	exact: true,
	// 	ssr: false,
	// 	component: "Booking",
	// 	mui: true,
	// },
];
